(function($, undefined) {
	
	'use strict';
	var formValidator;
	var updateElem;
	var initMapBtn;
	var geolocalisationInput;
	var appLocationDetailsForm;
	var clearLocationFormBtn;
	var mapId;
	var mapCtn;
	var repArtistsCtn;
	var filesInfos = '';
    var tools;
	
	var saveAppParams = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var sitePlanFrInput = form.find('.file-upload-input[name=plan-fr]');
		var sitePlanFr = sitePlanFrInput[0].files[0];
		var sitePlanEnInput = form.find('.file-upload-input[name=plan-en]');
		var sitePlanEn = sitePlanEnInput[0].files[0];
		var sitePlanErrorMsg = $('.js-form-error-message.plan-size');
		var fileTypeErrorMsg = $('.js-form-error-message.file-type');

		if (!sitePlanFr) { sitePlanFr = form.find('.file-upload-input[name=plan-en]')[0].files[0]; }
		if (!sitePlanEn) { sitePlanEn = form.find('.file-upload-input[name=plan-fr]')[0].files[0]; }

		$('.file-ctn').removeClass('error');
		sitePlanErrorMsg.slideUp();
		fileTypeErrorMsg.slideUp();
		form.removeClass('error-plan-file-size');
		form.removeClass('error-file-type');

		formValidator.validateForm(form);
		validateFileExtensions(form);
		validatePlanSize(sitePlanFrInput, form);
		validatePlanSize(sitePlanEnInput, form);

		if (!form.hasClass('has-error') && !form.hasClass('error-file-type') && !form.hasClass('error-plan-file-size')) {
			btn.addClass('disabled');

			var appId = form.find('input[name=app-id]').val();
			var social = {
				hashtag: form.find('input[name=hashtag]').val(),
				facebook: form.find('input[name=facebook]').val(),
				instagram: form.find('input[name=instagram]').val(),
				twitter: form.find('input[name=twitter]').val(),
				linkedin: form.find('input[name=linkedin]').val(),
				website: form.find('input[name=website]').val()
			};
			var bannerText = {
				fr: {
					h1: form.find('input[name=banner-h1-fr]').val().length > 0 ? form.find('input[name=banner-h1-fr]').val() : form.find('input[name=banner-h1-en]').val(),
					h2: form.find('input[name=banner-h2-fr]').val().length > 0 ? form.find('input[name=banner-h2-fr]').val() : form.find('input[name=banner-h2-en]').val(),
					link: form.find('input[name=banner-link-fr]').val().length > 0 ? form.find('input[name=banner-link-fr]').val() : form.find('input[name=banner-link-en]').val()
				},
				en: {
					h1: form.find('input[name=banner-h1-en]').val().length > 0 ? form.find('input[name=banner-h1-en]').val() : form.find('input[name=banner-h1-fr]').val(),
					h2: form.find('input[name=banner-h2-en]').val().length > 0 ? form.find('input[name=banner-h2-en]').val() : form.find('input[name=banner-h2-fr]').val(),
					link: form.find('input[name=banner-link-en]').val().length > 0 ? form.find('input[name=banner-link-en]').val() : form.find('input[name=banner-link-fr]').val()
				}
			};
			var colors = {
				splash: form.find('input[name=logo-background-color]').val(),
				main: form.find('input[name=main-color]').val(),
				text: form.find('input[name=app-text-color]:checked').val(),
				map: form.find('input[name=app-map-style]:checked').val()
			};
			var disabledPages = {
				artists: form.find('input[name=disable-artists-page]').prop('checked'),
				program: form.find('input[name=disable-program-page]').prop('checked'),
				tickets: form.find('input[name=disable-tickets-page]').prop('checked'),
				location: form.find('input[name=disable-location-page]').prop('checked'),
				merch: form.find('input[name=disable-merch-page]').prop('checked'),
				hashtag: form.find('input[name=disable-hashtag-page]').prop('checked')
			};

			var imageHomepageFr = form.find('.file-upload-input[name=homepage-fr]')[0].files[0];
			if (!imageHomepageFr) { imageHomepageFr = form.find('.file-upload-input[name=homepage-en]')[0].files[0];}

			var imageHomepageEn = form.find('.file-upload-input[name=homepage-en]')[0].files[0];
			if (!imageHomepageEn) { imageHomepageEn = form.find('.file-upload-input[name=homepage-fr]')[0].files[0]; }

			var data = {
				id: appId,
				field1: 'app',
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field6: JSON.stringify(getTextareaContent(form, 'app-description')),
				field7: JSON.stringify(getTextareaContent(form, 'practical-infos')),
				field8: JSON.stringify(getTextareaContent(form, 'terms-conditions')),
				field9: JSON.stringify(social),
				field10: JSON.stringify(colors),
				field11: JSON.stringify(bannerText),
				field12: JSON.stringify(disabledPages),
				ajax: true
			};

			if (appId === '') {
				data.field2 = 0;
			}

			if (!btn.hasClass('valid')) {
				data.field5 = form.find('input[name=app-name]').val();
			}

			var _updateData = function(data) {
				// console.log(data);

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function(response) {
						// console.log('app new/edit : ' + response);
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					},
					error: function (xhr, textStatus) {
						// console.error(textStatus);

						btn.removeClass('disabled');
					}
				});
			};

			uploadFile(form.find('.file-upload-input[name=logo]')[0].files[0], 'AppLogo', '-image.jpg', function() {
				if (filesInfos !== '' && !btn.hasClass('valid')) {
					data.field13 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
				}
				filesInfos = '';

				uploadMultipleSizeImage(form.find('.file-upload-input[name=logo-menu]')[0].files[0], 'AppMenuLogoBase', 'AppMenuLogoBase2x', 'AppMenuLogoBase3x', '-image.jpg', function() {
					if (filesInfos !== '') {
						data.field16 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					}
					filesInfos = '';

					uploadMultipleSizeImage(form.find('.file-upload-input[name=menu]')[0].files[0], 'AppMenuBase', 'AppMenuBase2x', 'AppMenuBase3x', '-image.jpg', function() {
						if (filesInfos !== '') {	
							data.field17 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
						}
						filesInfos = '';

						uploadMultipleSizeImage(imageHomepageFr, 'AppBannerBase', 'AppBannerBase2x', 'AppBannerBase3x', '-image.jpg', function() {
							if (filesInfos !== '') {
								data.field14 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
							}
							filesInfos = '';

							uploadMultipleSizeImage(imageHomepageEn, 'AppBannerBase', 'AppBannerBase2x', 'AppBannerBase3x', '-image.jpg', function() {
								if (filesInfos !== '') {
									data.field15 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
								}
								filesInfos = '';

								uploadFile(sitePlanFr, 'AppPlan', '-Default.jpg', function() {
									if (filesInfos !== '') {
										data.field18 = filesInfos;
									}
									filesInfos = '';

									uploadFile(sitePlanEn, 'AppPlan', '-Default.jpg', function() {
										if (filesInfos !== '') {
											data.field19 = filesInfos;
										}
										filesInfos = '';

										_updateData(data);
									}, false, 'Default');
								}, false, 'Default');
							});
						});
					});
				});
			});
		}

		if (form.hasClass('error-plan-file-size')) {
			sitePlanErrorMsg.slideDown();
		}

		if (form.hasClass('error-file-type')) {
			fileTypeErrorMsg.slideDown();
		}
	};

	var validatePlanSize = function(fileInput, form) {
		var maxSize = 1048576; // 1MB

		if (fileInput[0].files[0] !== undefined && fileInput[0].files[0].size > maxSize) {
			fileInput.closest('.input-ctn').addClass('error');
			form.addClass('error-plan-file-size');
		}
	};

	var validateFileExtensions = function(form) {
		form.find('.file-upload-input').each(function() {
			if ($(this)[0].files[0] !== undefined) {
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec($(this)[0].files[0].name)[1];
				// console.log(ext);

				if (ext.toLowerCase() !== 'jpg' && ext.toLowerCase() !== 'jpeg' && ext.toLowerCase() !== 'png') {
					$(this).closest('.input-ctn').addClass('error');
					form.addClass('error-file-type');
				}
			}
		});
	};

	var uploadSquareImage = function(image, callback) {
		var ext = '-image.jpg';

		uploadMultipleSizeImage(image, 'AppImgBase', 'AppImgBase2x', 'AppImgBase3x', ext, callback);
	};

	var uploadMultipleSizeImage = function(image, dir1, dir2, dir3, ext, callback) {
		if (image) {
			uploadFile(image, dir1, ext, function() {
				uploadFile(image, dir2, ext, function() {
					uploadFile(image, dir3, ext, function() {
						if (callback) {
							callback();
						}
					});
				});
			});
		} else if (callback) {
			callback();
		}
	};

	var createFileFormData = function(file, dir, noCrop) {
		var fd = new FormData();
		fd.append('image', file);
		fd.append('directory', dir);
		if (noCrop) {
			fd.append('noCrop', noCrop);
		}
		fd.append('ajax', 'true');
		fd.append('center', true);
		fd.append('scaleRatio', 0.001);

		return fd;
	};

	var uploadFile = function(file, dir, ext, callback, noCrop, saveDir) {
		if (!saveDir) {
			saveDir = dir;
		}
		if (file) {
			$.ajax({
				url: '/action/uploadCroppedImage',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: createFileFormData(file, dir, noCrop),
				success: function (response) {
					console.log('uploadFile: ', response);

					if (filesInfos.length > 0) {
						filesInfos += ',';
					}
					filesInfos += saveDir + '/' + $.trim(response.split('mediaId=')[1]) + ext;
					
					callback();
				},
				error: function (xhr, textStatus) {
					// console.error(textStatus);

					callback();
				}
			});
		} else if (callback) {
			callback();
		}
	};

	var getUpdateElem = function() {
		var t = $(this);
		updateElem = t.attr('data-update');

		MG2.ColorPicker.setColor(t.closest('.color-picker-icon-ctn').find('.form-input').val());
	};

	var changeColor = function() {
		var color = MG2.ColorPicker.getColor();
		var elem = $(updateElem);

		elem.css('background-color', color);
		elem.val(color);
		lightOrDark(elem);
	};

	// https://gist.github.com/larryfox/1636338
	var lightOrDark = function(t) {
		var r,b,g,hsp,
			a = t.css('background-color');
		
		if (a.match(/^rgb/)) {
			a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
			r = a[1];
			g = a[2];
			b = a[3];
		} else {
			a = +("0x" + a.slice(1).replace( // thanks to jed : http://gist.github.com/983661
					a.length < 5 && /./g, '$&$&'
				)
			);
			r = a >> 16;
			g = a >> 8 & 255;
			b = a & 255;
		}
		hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
			0.299 * (r * r) +
			0.587 * (g * g) +
			0.114 * (b * b)
		);
		if (hsp>127.5) {
			t.addClass('dark').removeClass('light');
		} else {
			t.addClass('light').removeClass('dark');
		}
	};

	var saveAppArtist = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var social = {
				"facebook": form.find('input[name=facebook]').val(),
				"instagram": form.find('input[name=instagram]').val(),
				"spotify": form.find('input[name=spotify]').val(),
				"youtube": form.find('input[name=youtube]').val()
			};

			let artistDescription = {
				"fr": form.find('textarea[name=artist-description-fr]').val(),
				"en": form.find('textarea[name=artist-description-en]').val()
			};

			var data = {
				id: form.find('input[name=artist-id]').val(),
				field1: 'artist',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: form.find('input[name=artist-name]').val(),
				field6: JSON.stringify(artistDescription),
				field7: JSON.stringify(social),
				ajax: true
			};

			// console.log(JSON.stringify(data));

			uploadSquareImage(form.find('.file-upload-input[name=artist]')[0].files[0], function() {
				if (filesInfos !== '') {
					data.field8 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					filesInfos = '';
				}

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function(response) {
						// console.log('artist new/edit : ' + response);

						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				});
			});
		}
	};

	var deleteGenData = function(btn, deleteConfirmed) {
		if (btn.length === undefined) {
			btn = $(this);
		}

		if (deleteConfirmed) {
			btn.addClass('disabled');
			var data = {
				id: btn.attr('data-id'),
				delete: true,
				ajax: true
			};

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function(response) {
					// console.log('delete GenData : ' + response);
					if (btn.hasClass('remove-artist-from-representation')) {
						deleteArtistFromRep(btn);
					} else {
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				}
			});
		} else {
			confirmDelete(btn);
		}
	};

	var confirmDelete = function(btn, isOrg) {
		var popup = $('#app-admin-confirm-delete-popup');
		var overlay = $('.overlay', 'body');

		popup.addClass('open');
		overlay.addClass('active');

		popup.find('.confirm-delete-btn').click(function() {
			popup.find('.confirm-delete-btn').off('click');
			popup.removeClass('open');
			overlay.removeClass('active');
			
			if (isOrg) {
				deleteOrganization(btn, true);
			} else {
				deleteGenData(btn, true);
			}
		});

		popup.find('.popup-inner-close').one('click', function() {
			popup.find('.confirm-delete-btn').off('click');
		});
	};

	var deleteArtistFromRep = function(btn) {
		var id = btn.attr('data-id');
		var repsToEdit = $('.representation-to-edit-' + id);
		var total = repsToEdit.length;
		var count = 0;

		repsToEdit.each(function() {
			var rep = $(this);
			var data = {
				id: rep.attr('data-id'),
				field8: rep.attr('data-artists'),
				ajax: true
			};
			
			count++;

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function(response) {
					// console.log('edit representation GenData : ' + response);
					
					if (count >= total) {
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				}
			});
		});
	};

	var filterAppArtists = function() {
		var input = $(this);
		var q = input.val().toLowerCase();
		var ctn = input.closest('.box-theme-ctn');
		var notFound = $('.app-admin-artists-not-found');

		if (q === '') {
			$('.app-artist').removeClass('hide-search');
			notFound.slideUp();
			return false;
		}

		$('.app-admin-list .app-artist').each(function () {
			var t = $(this);
			var name = t.find('.app-artist-name').html().toLowerCase();
			var isOk = false;
			
			if (name.indexOf(q) !== -1) {
				isOk = true;
			}

			isOk ?  t.removeClass('hide-search') : t.addClass('hide-search');
		});

		$('.app-admin-list .app-artist:not(.hide-search)').length === 0 ? notFound.slideDown() : notFound.slideUp();
	};

	var saveAppLocation = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var addr = form.find('input[name="geolocalisation"]').val();
		var hiddenLat = form.find('input[name="hiddenLat"]').val();
		var city = form.find('input[name=city]').val();
		var province = form.find('input[name=province]').val();
		var country = form.find('input[name=country]').val();
		var postalCode = form.find('input[name=postalCode]').val();

		if (addr.length && city.length && province.length 
			&& country.length && postalCode.length && !hiddenLat.length) {

			btn.addClass('disabled');

			fetchLocation(addr, city, province, country, postalCode, function(lat, lng) {
				if (lat && lng) {
					form.find('input[name="hiddenLat"]').val(lat);
					form.find('input[name="hiddenLng"]').val(lng);
				} 
				btn.removeClass('disabled');
				completeFormValidation(form, btn);
			});

			return;
		}

		completeFormValidation(form, btn);
	};

	var fetchLocation = function(addr, city, province, country, postalCode, callback) {
		var geocoder = new google.maps.Geocoder();
		var coorUrl = [addr, city, province, country, postalCode].join(', ');
		

		geocoder.geocode({'address': coorUrl}, function(results, status) {
			var lat, lng;
			if (status === google.maps.GeocoderStatus.OK) {
				var lat = results[0].geometry.location.lat();
				var lng = results[0].geometry.location.lng();
			}

			if (typeof callback === 'function') {
				callback(lat, lng);
			}
		});
	};

	var completeFormValidation = function(form, btn) {
		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			var hiddenLat = form.find(':not(.disabled) input[name="hiddenLat"].error');
			console.log('invalid address');
			if (hiddenLat.length) {
				form.find('.invalid-address').show();
				form.find('input[name="geolocalisation"]').removeClass('success').addClass('error');
			} else {
				form.find('.invalid-address').hide();
			}
		} else if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var data = {
				id: form.find('input[name=location-id]').val(),
				field1: false,
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				name: form.find('input[name=location-name]').val(),
				ajax: true
			};

			if (form.find('input[name=geolocalisation]').val().length > 0) {
				data.address = form.find('input[name=geolocalisation]').val();
				data.city = form.find('input[name=city]').val();
				data.province = form.find('input[name=province]').val();
				data.country = form.find('input[name=country]').val();
				data.postalCode = form.find('input[name=postalCode]').val();
				if(form.find('input[name=hiddenLat]').val().length > 0) {
					data.lat = form.find('input[name=hiddenLat]').val();
					data.lng = form.find('input[name=hiddenLng]').val();
				}
			} else if (form.find('input[name=latitude]').val().length > 0) {
				data.lat = form.find('input[name=latitude]').val();
				data.lng = form.find('input[name=longitude]').val();
			} else if (form.find('input[name=latMap]').val().length > 0) {
				data.field1 = true;
				data.lat = form.find('input[name=latMap]').val();
				data.lng = form.find('input[name=lngMap]').val();
			}

			// console.log(JSON.stringify(data));

			$.ajax({
				url: '/action/addOrganization',
				cache: false,
				data: data,
				method: 'POST',
				success: function(response) {
					// console.log('location new/edit : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var handleLocationInputs = function(t, forceHasVal) {
		if (t.length === undefined) {
			t = $(this);
		}
		var ctn = t.closest(appLocationDetailsForm);
		var hasVal;

		ctn.find('.form-input').each(function() {
			if ($(this).val().length > 0) {
				hasVal = true;
				return;
			}
		});

		if (hasVal || forceHasVal) {
			ctn.find('.clear-addr-btn').slideDown();
			appLocationDetailsForm.each(function() {
				if ($(this).attr('class') !== ctn.attr('class')) {
					$(this).find('input').removeClass('required error');
					$(this).addClass('disabled');
				}
			});
		} else {
			ctn.find('.clear-addr-btn').slideUp();
			$('.app-location-details-form input').addClass('required');
			appLocationDetailsForm.removeClass('disabled');
		}
	};

	var clearLocationForm = function() {
		clearLocationFormBtn.slideUp();
		appLocationDetailsForm.removeClass('disabled');
		appLocationDetailsForm.find('input').val('').removeClass('error success place-found').addClass('required').closest('.input-ctn').removeClass('focused');
	};

	var deleteOrganization = function(btn, deleteConfirmed) {
		if (btn.length === undefined) {
			btn = $(this);
		}

		if (deleteConfirmed) {
			btn.addClass('disabled');

			$.ajax({
				url: '/action/deleteOrganization',
				cache: false,
				data: {
					id: btn.attr('data-id'),
					ajax : true
				},
				method: 'POST',
				success: function(response) {
					// console.log('location delete : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		} else {
			confirmDelete(btn, true);
		}
	};

	var initLocationMap = function() {
		var btn = $('.init-location-map-btn');
		var ctn = btn.closest('.app-location-details-form');
		var lat;
		var lng;

		$('input[name=latMap]').val() === '' ? lat = mapCtn.attr('data-defaultlat') : lat = $('input[name=latMap]').val();
		$('input[name=lngMap]').val() === '' ? lng = mapCtn.attr('data-defaultlng') : lng = $('input[name=lngMap]').val();

		var myLatlng = new google.maps.LatLng(lat, lng);
		var mapOptions = {
			zoom: 10,
			center: myLatlng,
	  		streetViewControl: false,
	  		fullscreenControl: false
		};
		
		var map = new google.maps.Map(document.getElementById(mapId), mapOptions);
		var marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			title: name,
			draggable: true,
			icon: '/static/assets/img/pin.png'
		});

		$('#'+mapId).addClass('activated');
		handleLocationInputs(btn, true);
		btn.slideUp();

		map.addListener('click', function(event) {
			updateMarkerLocation(event.latLng.lat(), event.latLng.lng(), marker);
		});

		marker.addListener('dragend', function() {
			updateMarkerLocation(marker.getPosition().lat(), marker.getPosition().lng(), marker);
		});
	};

	var updateMarkerLocation = function(lat, lng, marker) {
		var ctn = $('.app-location-details-form.map-click');

		marker.setPosition(new google.maps.LatLng(lat, lng));
		ctn.find('input[name=latMap]').val(lat);
		ctn.find('input[name=lngMap]').val(lng);
		// console.log(lat + ', ' + lng);
	};

	var clearMap = function() {
		mapCtn.empty().removeClass('activated');
		initMapBtn.slideDown();

		$('input[name=latMap]').val(mapCtn.attr('data-defaultlat'));
		$('input[name=lngMap]').val(mapCtn.attr('data-defaultlng'));
	};

	var setEditLocationPopup = function() {
		var btn = $(this);
		var popup = $('.' + btn.attr('data-id'));

		clearMap();
		clearLocationForm();
		popup.find('.js-form-error-message').slideUp();

		popup.find('input[name=location-id]').val(btn.attr('data-locationid'));
		popup.find('input[name=location-name]').val(btn.attr('data-name'));

		if (btn.attr('data-address').length !== 0) {
			popup.find('input[name=geolocalisation]').val(btn.attr('data-address'));
			popup.find('input[name=city]').val(btn.attr('data-city'));
			popup.find('input[name=province]').val(btn.attr('data-province'));
			popup.find('input[name=country]').val(btn.attr('data-country'));
			popup.find('input[name=postalCode]').val(btn.attr('data-postalCode'));
			popup.find('input[name=hiddenLat]').val(btn.attr('data-lat'));
			popup.find('input[name=hiddenLng]').val(btn.attr('data-lng'));
			handleLocationInputs(popup.find('input[name=geolocalisation]'));
		} else if (btn.data('map')) {
			popup.find('input[name=latMap]').val(btn.attr('data-lat'));
			popup.find('input[name=lngMap]').val(btn.attr('data-lng'));
			initLocationMap();
		} else if (btn.attr('data-lat').length !== 0) {
			popup.find('input[name=latitude]').val(btn.attr('data-lat'));
			popup.find('input[name=longitude]').val(btn.attr('data-lng'));
			handleLocationInputs(popup.find('input[name=latitude]'));
		}

		popup.find('input').each(function() {
			if ($(this).val().length > 0) {
				$(this).removeClass('error').closest('.input-ctn').addClass('focused');
			} else {
				$(this).removeClass('error success').closest('.input-ctn').removeClass('focused');
			}
		});
	};

	var filterAppLocations = function() {
		var input = $(this);
		var q = input.val().toLowerCase();
		var ctn = input.closest('.box-theme-ctn');
		var notFound = $('.app-admin-locations-not-found');

		if (q === '') {
			$('.app-location').removeClass('hide-search');
			notFound.slideUp();
			return false;
		}

		$('.app-admin-list .app-location').each(function () {
			var t = $(this);
			var name = t.find('.app-location-name').html().toLowerCase();
			var address = t.find('.app-location-address').html() !== undefined ? t.find('.app-location-address').html().toLowerCase() : '';
			var isOk = false;
			
			if (name.indexOf(q) !== -1 || address.indexOf(q) !== -1) {
				isOk = true;
			}

			isOk ?  t.removeClass('hide-search') : t.addClass('hide-search');
		});

		$('.app-admin-list .app-location:not(.hide-search)').length === 0 ? notFound.slideDown() : notFound.slideUp();
	};

	var updateRepresentationArtistsList = function() {
		var btn = $(this);

		repArtistsCtn.find('.app-representation-artist-img-ctn:not(.popup-btn)').remove();

		$('.representation-artist-check:checked').each(function() {
			var clone = $('.app-representation-artist-img-ctn[data-artist=clone]').clone();
			var imgCtn = clone.find('.representation-artist-img');
			var infos = $(this).closest('.form-checkbox-ctn').find('.representation-artist-info');
			
			if (infos.attr('data-img').length > 0) {
				imgCtn.attr('style', imgCtn.attr('data-prefix') + infos.attr('data-img') + imgCtn.attr('data-suffix'));
			}

			clone.find('.featured-event-add-event-text').html(infos.html());
			clone.attr('data-artist', infos.attr('data-id'));
			clone.removeClass('clone');

			repArtistsCtn.append(clone);
			clone.fadeIn();
		});
		
		repArtistsCtn.find('.app-representation-artist-img-ctn.popup-btn').detach().appendTo(repArtistsCtn);
		btn.closest('.popup').find('.popup-inner-close').trigger('click');
	
		updateListInput();
	};

	var updateListInput = function() {
		var artists = [];

		repArtistsCtn.find('.app-representation-artist-img-ctn:not(.popup-btn)').each(function() {
			artists.push($(this).attr('data-artist'));
		});

		$('input[name=artists-list]').val(artists.join());
	};

	var removeRepresentationArtist = function() {
		var id = $(this).closest('.app-representation-artist-img-ctn').attr('data-artist');
		// console.log(id);

		$(this).closest('.app-representation-artist-img-ctn').fadeOut(function() {
			$(this).remove();
			$('.app-representation-add-artist-popup').find('.representation-artist-check[value=' + id + ']').prop('checked', false);
			updateListInput();
		});
	};

	var saveRepresentation = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');
			var artists = '';
			var tickets = [];

			if (form.find('input[name="no-artists"]:checked').length === 0) {
				artists = form.find('input[name=artists-list]').val();
			}

			if ($('.app-event-tickets-ctn.open').length > 0) {
				$('.app-event-tickets-ctn.open').find('input[name="ticket-check"]:checked').each(function() {
					tickets.push($(this).val());
				});
			}

			var data = {
				id: form.find('input[name=representation-id]').val(),
				field1: 'representation',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: form.find('input[name=name]').val(),
				field6: form.find('textarea[name=description]').val(),
				field7: form.find('select[name=representation-location]').val(),
				field8: artists,
				field9: form.find('input[name="show-rep-homepage"]').prop('checked'),
				field10: form.find('select[name=representation-event]').val(),
				field12: form.find('input[name=hide-doors]').prop('checked'),
				dateField1Year: form.find('input[name=startDateYear]').val(),
				dateField1Month: form.find('input[name=startDateMonth]').val(),
				dateField1Day: form.find('input[name=startDateDay]').val(),
				dateField1Hour: form.find('input[name=startDateHour]').val(),
				dateField1Minute: form.find('input[name=startDateMinute]').val(),
				dateField2Year: form.find('input[name=endDateYear]').val(),
				dateField2Month: form.find('input[name=endDateMonth]').val(),
				dateField2Day: form.find('input[name=endDateDay]').val(),
				dateField2Hour: form.find('input[name=endDateHour]').val(),
				dateField2Minute: form.find('input[name=endDateMinute]').val(),
				dateField3Year: form.find('input[name=startDateYear]').val(),
				dateField3Month: form.find('input[name=startDateMonth]').val(),
				dateField3Day: form.find('input[name=startDateDay]').val(),
				dateField3Hour: form.find('input[name=doorDateHour]').val(),
				dateField3Minute: form.find('input[name=doorDateMinute]').val(),
				field13: tickets.join(),
				ajax: true
			};

			// console.log(JSON.stringify(data));

			uploadSquareImage(form.find('.file-upload-input[name=representation]')[0].files[0], function() {
				if (filesInfos !== '') {
					data.field11 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					filesInfos = '';
				}

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function(response) {
						// console.log('representation new/edit : ' + response);

						if (response.indexOf('success') !== -1) {
							window.location.href = btn.attr('data-forward');
						} else {
							btn.removeClass('disabled');
						}
					}
				});
			});
		}
	};

	var showAssociatedTickets = function() {
		var eventId = $(this).val();

		$('.app-event-tickets-ctn').each(function() {
			if ($(this).attr('data-event') != eventId) {
				$(this).removeClass('open').slideUp();
			}
		});

		if (eventId !== '' && $('.app-event-tickets-ctn[data-event=' + eventId + ']').length > 0) {
			$('.app-event-tickets-ctn[data-event=' + eventId + ']').addClass('open').slideDown();
			$('.representation-tickets-box').slideDown();
		} else {
			$('.representation-tickets-box').slideUp();
		}
	};

	var submitAppForApproval = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var newDate = new Date();

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: btn.attr('data-id'),
					field2: 1,
					dateField1Year: newDate.getFullYear(),
					dateField1Month: newDate.getMonth(),
					dateField1Day: newDate.getDate(),
					dateField1Hour: newDate.getHours(),
					dateField1Minute: newDate.getMinutes(),
					dateField1Second: newDate.getSeconds(),
					ajax : true
				},
				method: 'POST',
				success: function (response) {
                    // console.log('submit app : ' + response);
                    if (response.indexOf('success') !== -1) {
                        var id = response.substring(8);
                        ajax("/action/epAddAlert?ajax=true&type=10&field1="+id, function (response) {
                            window.location.reload();
                        }, true);
                    } else {
                        btn.removeClass('disabled');
                    }
                }
            });
		}
	};

	var saveAppStatus = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');
            var email = btn.attr("data-email");
            var lang = $("html").attr('lang');
			var status = $('select[name=change-app-status]').val();
            var currStatus = btn.parent().attr("data-status");

			var data = {
				id: btn.attr('data-id'),
				field2: status,
				ajax : true
			};

			if (status === '2') {
				var newDate = new Date();
				data.dateField2Year = newDate.getFullYear();
				data.dateField2Month = newDate.getMonth();
				data.dateField2Day = newDate.getDate();
				data.dateField2Hour = newDate.getHours();
				data.dateField2Minute = newDate.getMinutes();
				data.dateField2Second = newDate.getSeconds();
			}

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function(response) {
//					console.log('app status change: ' + response);
					if (response.indexOf('success') !== -1) {
                        if ((status === '2' || status === '3') && currStatus !== status) {
                            var subject = (status === '2') ? (lang === "fr" ? "Votre demande pour une application mobile a été acceptée!" : "Your request for a mobile app has been approved!") : (lang === "fr" ? "Votre demande pour une application mobile a été refusée" : "Your request for a mobile app has been denied");
                            var file = (status === '2') ? "app-approved-" + lang : "app-refused-" + lang;
                            tools.sendEmail(email, subject, null, file, null, function (response) {
                                window.location.reload();
                            });
                        } else {
                            window.location.reload();                            
                        }
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var getTextareaContent = function(form, name) {
		var contentFr = tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent() !== '' ? tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent() : tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent();
		var contentEn = tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent() !== '' ? tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent() : tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent();

		return {fr: contentFr, en: contentEn};
	};

	var saveAppAlert = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var alertNameFr = form.find('input[name=title-fr]').val().length > 0 ? form.find('input[name=title-fr]').val() : form.find('input[name=title-en]').val();
		var alertNameEn = form.find('input[name=title-en]').val().length > 0 ? form.find('input[name=title-en]').val() : form.find('input[name=title-fr]').val();

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var data = {
				id: form.find('input[name=alert-id]').val(),
				field1: 'alert',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: JSON.stringify({fr: alertNameFr, en: alertNameEn}),
				field6: JSON.stringify(getTextareaContent(form, 'alert-description')),
				dateField1Year: form.find('input[name=startDateYear]').val(),
				dateField1Month: form.find('input[name=startDateMonth]').val(),
				dateField1Day: form.find('input[name=startDateDay]').val(),
				dateField1Hour: form.find('input[name=startDateHour]').val(),
				dateField1Minute: form.find('input[name=startDateMinute]').val(),
				ajax: true
			};

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function(response) {
					// console.log('alert new/edit : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var openAppPreviewMenu = function() {
		$('.mobile-app-preview-screen').addClass('pushed');
	};

	var closeAppPreviewMenu = function() {
		$('.mobile-app-preview-screen').removeClass('pushed');
	};

	var fadeOutSplashscreen = function() {
		var splashscreen = $('.mobile-app-preview-splashscreen');

		if (splashscreen.length > 0) {	
			setTimeout(function() {
				splashscreen.fadeOut();
			}, 3000);
		}
	};

	var deleteGenDataImage = function() {
		var btn = $(this);
		var data = {
			id: btn.attr('data-id'),
			ajax: true
		};

		data[btn.attr('data-field')] = '';

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function(response) {
				// console.log('delete iamge: ' + response);

				window.location.reload();
			}
		});
	};

	var init = function () {
        tools = Fw.component.models().tools;
		formValidator = Fw.component.models().form;
		geolocalisationInput = $('input[name=geolocalisation]');
		appLocationDetailsForm = $('.app-location-details-form');
		initMapBtn = $('.init-location-map-btn');
		mapId = 'app-location-click-map-ctn';
		mapCtn = $('#'+ mapId);
		clearLocationFormBtn = $('.clear-addr-btn');
		repArtistsCtn = $('.representation-artists-ctn');

		$('.lang-input-toggle-ctn').removeClass('disabled');
		fadeOutSplashscreen();

		if (geolocalisationInput.length > 0) {
			profile.activateGlgAutocomplete();
			profile.checkAddress();
			
			setTimeout(function() {
				geolocalisationInput.removeAttr("placeholder");
			}, 200);
		}

		$('.color-picker-input').each(function() {
			lightOrDark($(this));
		});

		$('.save-app-params-btn').click(saveAppParams);
		$('.color-picker-input-ctn .color-picker-icon.popup-btn').click(getUpdateElem);
		$('.color-picker-input-popup .mg2-color-current, .color-picker-input-popup .popup-inner-close').click(changeColor);
		$('.save-app-artist-btn').click(saveAppArtist);
		$('.delete-gendata-btn').click(deleteGenData);
		$('input[name=search-artists]').keyup(filterAppArtists);
		$('.save-app-location-btn').click(saveAppLocation);
		$('.app-location-details-form .form-input').keyup(handleLocationInputs);
		clearLocationFormBtn.click(clearLocationForm);
		$('.app-location-details-form.map-click .clear-addr-btn').click(clearMap);
		$('.delete-organization-btn').click(deleteOrganization);
		initMapBtn.click(initLocationMap);
		$('.app-edit-location-btn').click(setEditLocationPopup);
		$('input[name=search-locations]').keyup(filterAppLocations);
		$('.update-representation-artists-list-btn').click(updateRepresentationArtistsList);
		$('.save-representation-btn').click(saveRepresentation);
		$('.representation-event').change(showAssociatedTickets);
		$('.delete-representation-btn').click(deleteGenData);
		$('.submit-app-btn').click(submitAppForApproval);
		$('.save-app-status-btn').click(saveAppStatus);
		$('.save-app-alert-btn').click(saveAppAlert);
		$('.delete-alert-btn').click(deleteGenData);
		$('.app-img-delete-btn-js').click(deleteGenDataImage);
		if ($('.remove-representation-artist-btn').length > 0) {
			$('body').on('click', '.remove-representation-artist-btn', removeRepresentationArtist);
		}
		if ($('.open-app-preview-menu-btn').length > 0) {
			$('body').on('click', '.mobile-app-preview-screen:not(.pushed) .open-app-preview-menu-btn', openAppPreviewMenu);
		}
		if ($('.mobile-app-preview-main').length > 0) {
			$('body').on('click', '.mobile-app-preview-screen.pushed .mobile-app-preview-main', closeAppPreviewMenu);
		}

	};
	
	$(window).on('load',function(){
		init();
	});
	
})(jQuery);